export const state = () => ({
  stats: [],
  breadcrumbs: [],
  snackbar: false,
  snackbarMsg: '',
  notificationsResponse: { data: [] },
  showNotificationsDot: false,
  numberOfUnseenNotifications: 0,
  isMobile: false,
  currentLang: ''
})

export const mutations = {
  updateBreadcrumbs (state, value) {
    state.breadcrumbs = value
  },
  updateStats (state, value) {
    state.stats = value
  },
  setSnackbar (state, value) {
    state.snackbar = value
  },
  setSnackbarMsg (state, value) {
    state.snackbarMsg = value
  },
  setNotificationsResponse (state, value) {
    state.notificationsResponse = value
  },
  setShowNotificationsDot (state, value) {
    state.showNotificationsDot = value
  },
  setNumberOfUnseenNotifications (state, value) {
    state.numberOfUnseenNotifications = value
  },
  setIsMobile (state, value) {
    state.isMobile = value
  },
  setCurrentLang (state, value) {
    state.currentLang = value
  }
}
